// Эндпоинты, секции и лимиты поиска туров — как в searchCache.js / session.js монолита.
export const TOUR_SEARCH_CACHE_PATH = '/frontend/tours';
export const TOUR_SEARCH_GROUPED_CACHE_PATH = '/frontend/groupedTours';
export const TOUR_SEARCH_SECTIONS: readonly string[] = [
  'hotels',
  'countries',
  'firstPaymentDefinitions',
  'operators',
  'sortRate',
  'hotelPhotos',
];
export const TOUR_SEARCH_LIMITS = { sync: 20000, final: 20000 };
